import { render, staticRenderFns } from "./UserCourier.vue?vue&type=template&id=ebd86e8c"
import script from "./UserCourier.vue?vue&type=script&lang=js"
export * from "./UserCourier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports